import { render, staticRenderFns } from "./CurriculumMainT.vue?vue&type=template&id=82debbfc&scoped=true&"
import script from "./CurriculumMainT.vue?vue&type=script&lang=ts&"
export * from "./CurriculumMainT.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumMainT.vue?vue&type=style&index=0&id=82debbfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82debbfc",
  null
  
)

export default component.exports